var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"value":true,"persistent":"","max-width":_vm.width,"color":"secondary","fullscreen":_vm.fullscreen}},[_c('v-card',[_c('v-card-title',{staticClass:"headline secondary"},[_vm._t("title")],2),_c('v-card-text',[_vm._t("default")],2),_c('v-card-actions',[_vm._t("actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }